<ion-item-sliding #itemSliding>
  <ion-item
    lines="none"
    mode="md"
    color="white"
    class="separator item-product"
    [ngClass]="{
      suggested: producto.modelo === 0,
      gamification: producto.modelo === 1,
      keyaccounts: producto.modelo === 4
    }"
  >
    <ion-grid fixed class="no-padding-left no-padding-right">
      <ion-row>
        <!-- * Titulo y descripcion de los productos -->
        <ion-col
          [size]="colDescrip"
          class="ion-align-self-center no-padding-left"
        >
          <ion-label
            mode="md"
            color="status-icon-enable"
            class="content-decript"
          >
            <ng-container *ngIf="drawer">
              <ng-container *ngIf="producto.isNew">
                <ion-badge mode="ios" color="tpcta" class="new-edit">
                  {{ 'Labels.new' | translate }}
                </ion-badge>
              </ng-container>

              <ng-container *ngIf="producto.isEdit && producto.newAdd !== 0">
                <ion-text
                  mode="md"
                  [color]="producto.newAdd > 0 ? 'tpcta' : 'cherry'"
                  class="new-edit"
                >
                  {{
                    producto.newAdd > 0
                      ? '+' + producto.newAdd
                      : producto.newAdd
                  }}
                </ion-text>
              </ng-container>
            </ng-container>

            <p
              class="title"
              [attr.data-test]="'Automation.txt-productcard-title' | translate"
            >
              {{ producto.title }}
            </p>
            <p
              class="subtitle"
              [attr.data-test]="
                'Automation.txt-productcard-presentation' | translate
              "
            >
              <ng-container *ngIf="producto.subtitle | highlightUnits as parts">
                {{ parts.label }}
                <ion-text
                  mode="md"
                  [color]="warningSelector ? 'tpcta' : 'status-icon-enable'"
                >
                  {{ parts.units }}
                </ion-text>
              </ng-container>
            </p>

            <p
              class="taste"
              [attr.data-test]="'Automation.txt-productcard-flavor' | translate"
            >
              {{ 'Labels.taste' | translate }}:&nbsp;{{ producto.sku }}
              <br />
              <ng-container *ngIf="!isFactorCl">
                <b
                  [attr.data-test]="
                    'Automation.txt-productcard-factorcl' | translate
                  "
                >
                  {{ 'Labels.factorcl' | translate }}: {{ producto.FactorCl }}
                </b>
              </ng-container>
            </p>
          </ion-label>
        </ion-col>

        <!-- * Rango selector -->
        <ion-col [size]="colButtoms" class="ion-align-self-center">
          <ng-container *ngIf="resetRange; else resetRangeFalse">
            <ion-skeleton-text
              style="width: 80px; height: 30px"
            ></ion-skeleton-text>
          </ng-container>

          <ng-template #resetRangeFalse>
            <range-input
              [initial]="producto.productos"
              [configurations]="
                producto.modelo === 0 ? maxRange(0) : rangeInput
              "
              [warningSelector]="warningSelector"
              (comeBack)="comeBack($event)"
            ></range-input>
          </ng-template>
        </ion-col>

        <!-- * Precio unitario y total -->
        <ion-col
          size="4"
          class="ion-justify-content-end ion-align-items-center no-padding-right col-more"
        >
          <ion-label class="ion-text-end" color="tpcta">
            <p
              class="subtitle price-minor"
              [attr.data-test]="'Automation.txt-productcard-price' | translate"
            >
              {{ producto.precio | currency }}
            </p>
            <p
              class="title"
              [attr.data-test]="
                'Automation.txt-productcard-price-total' | translate
              "
            >
              {{ producto.precio * producto.productos | currency }}
            </p>
          </ion-label>

          <ion-button
            fill="clear"
            class="ion-no-padding button-more"
            color="darkblue"
            (click)="onMore($event, producto)"
            [attr.data-test]="'Automation.txt-productcard-delete' | translate"
          >
            <ion-icon name="ellipsis-vertical"></ion-icon>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-item>

  <!-- * Eliminar -->
  <ion-item-options side="end" class="separator">
    <ion-item-option color="light" (click)="onDelete(producto)">
      <ion-icon slot="icon-only" name="trash-blue" color="darkblue"></ion-icon>
    </ion-item-option>
  </ion-item-options>
</ion-item-sliding>
